/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit'
import { PlacementList, PlacementListResponse, getPlacementList } from '../api/registration'
import { RootState } from './rootReducer'

interface State {
  placements: PlacementList[] | null
  totalCount: number
  totalPages: number
  currentLimit: number
  currentPage: number

  loading: 'idle' | 'pending'
  error: SerializedError | null
}

const initialState: State = {
  placements: null,
  totalCount: 0,
  totalPages: 0,
  currentLimit: 0,
  currentPage: 0,
  loading: 'idle',
  error: null,
}

export const fetchPlacementList = createAsyncThunk<
  PlacementListResponse,
  {
    page: number
    limit: number
    year?: string
  },
  {
    state: RootState
  }
>('placements/fetchPlacementList', async ({ page, limit, year }) => {
  const response = await getPlacementList(limit, page, year)
  return response
})

const slice = createSlice({
  name: 'placements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPlacementList.pending, (state) => {
      state.placements = null
      state.totalCount = 0
      state.totalPages = 0
      state.currentLimit = 0
      state.currentPage = 0
      state.error = null
      state.loading = 'pending'
    })
    builder.addCase(fetchPlacementList.fulfilled, (state, { payload }) => {
      state.placements = payload.placements
      state.totalCount = payload.totalCount
      state.totalPages = payload.totalPages
      state.currentLimit = payload.currentLimit
      state.currentPage = payload.currentPage
      state.loading = 'idle'
    })
    builder.addCase(fetchPlacementList.rejected, (state, action) => {
      state.error = action.error
      state.loading = 'idle'
    })
  },
})

// export const { } = slice.actions

export default slice.reducer
